import type { IconProps } from './types';

export const AlbumIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M3 6.25L21 6.25M5 3.25H19M1 9H23V22H1V9Z" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
